import { useState } from 'react';

export default function FaqSection() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  const faqs = [
    {
      question: 'A análise do meu caso é realmente gratuita?',
      answer: 'Sim, 100% gratuita. Você envia as informações, analisamos seu caso e damos um retorno sem cobrar nada. Só há cobrança de honorários se você decidir seguir com a ação e ganhar a indenização.'
    },
    {
      question: 'Quanto vou pagar para começar?',
      answer: 'Nada. Você não paga nenhum valor adiantado. Trabalhamos com honorários de êxito, ou seja, só cobramos se você receber a indenização. Se não ganhar, você não paga.'
    },
    {
      question: 'Quanto tempo demora para receber a indenização?',
      answer: 'O prazo varia conforme cada caso e a complexidade do processo judicial. Em média, processos de indenização por problemas com voos levam de 6 meses a 2 anos. Mantemos você informado em todas as etapas.'
    },
    {
      question: 'Preciso ir ao fórum ou comparecer em audiências?',
      answer: 'Na maioria dos casos, não. Cuidamos de toda a parte processual. Se for necessária sua presença em alguma audiência, avisamos com antecedência e explicamos tudo. Muitas audiências hoje são online.'
    },
    {
      question: 'Meu voo atrasou há 2 anos. Ainda posso pedir indenização?',
      answer: 'Sim! Você tem até 5 anos a partir da data do problema para entrar com ação de indenização. Mesmo que tenha acontecido há meses ou anos, ainda dá tempo de buscar seus direitos.'
    },
    {
      question: 'Vocês atendem em todo o Brasil?',
      answer: 'Sim, atendemos clientes em todos os estados brasileiros de forma 100% online. Você não precisa vir até nosso escritório — tudo é feito por WhatsApp, e-mail e videochamada.'
    },
    {
      question: 'Como sei se meu caso tem chance de ganhar?',
      answer: 'Fazemos uma análise técnica baseada nas normas da ANAC, no Código de Defesa do Consumidor e na jurisprudência dos tribunais. Se identificarmos que há boas chances, explicamos tudo de forma clara antes de você decidir seguir em frente.'
    },
    {
      question: 'Preciso ter guardado os documentos do voo?',
      answer: 'É importante, mas não é obrigatório ter todos os documentos. Com as informações básicas (data, companhia aérea, número do voo), conseguimos buscar os dados necessários. Quanto mais documentos você tiver, melhor, mas a falta deles não impede a análise.'
    },
    {
      question: 'A companhia aérea pode me prejudicar se eu processar?',
      answer: 'Não. Você tem o direito garantido por lei de buscar indenização. A companhia aérea não pode te prejudicar, te impedir de voar novamente ou tomar qualquer represália. É seu direito como consumidor.'
    },
    {
      question: 'Como funciona o pagamento dos honorários?',
      answer: 'Só cobramos honorários se você ganhar a indenização. O percentual é acordado antes de iniciar o processo e é descontado do valor que você recebe. Se não houver ganho, você não paga nada.'
    }
  ];

  return (
    <section className="py-24 bg-white">
      <div className="max-w-4xl mx-auto px-6">
        <div className="text-center mb-16">
          <span className="inline-block bg-teal-50 text-teal-700 text-xs font-bold uppercase tracking-widest px-5 py-2 rounded-full mb-4">
            Tire Suas Dúvidas
          </span>
          <h2 className="text-4xl md:text-5xl font-bold text-gray-900 mb-6 font-serif">
            Perguntas Frequentes
          </h2>
          <p className="text-xl text-gray-700 max-w-2xl mx-auto leading-relaxed">
            Respondemos as principais dúvidas sobre indenização por problemas com voos.
          </p>
        </div>

        <div className="space-y-4">
          {faqs.map((faq, index) => (
            <div
              key={index}
              className="bg-gradient-to-br from-gray-50 to-white rounded-xl border-2 border-gray-200 hover:border-teal-400 transition-all duration-300 overflow-hidden"
            >
              <button
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
                className="w-full flex items-center justify-between p-6 text-left cursor-pointer"
              >
                <h3 className="text-lg font-bold text-gray-900 pr-4">
                  {faq.question}
                </h3>
                <i
                  className={`text-2xl text-teal-600 transition-transform duration-300 flex-shrink-0 ${
                    openIndex === index ? 'ri-subtract-line' : 'ri-add-line'
                  }`}
                ></i>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96' : 'max-h-0'
                }`}
              >
                <div className="px-6 pb-6">
                  <p className="text-gray-700 leading-relaxed">{faq.answer}</p>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="mt-12 bg-gradient-to-r from-teal-50 to-teal-100/50 rounded-2xl p-8 text-center border border-teal-200">
          <p className="text-xl font-bold text-gray-900 mb-4">
            Ainda tem dúvidas?
          </p>
          <p className="text-gray-700 mb-6">
            Fale diretamente com nossa equipe pelo WhatsApp. Respondemos rapidamente.
          </p>
          <a
            href="https://wa.me/5528998813826?text=Ol%C3%A1%2C%20tenho%20algumas%20d%C3%BAvidas%20sobre%20indeniza%C3%A7%C3%A3o%20por%20problema%20com%20voo.%20Pode%20me%20ajudar%3F"
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-3 bg-green-600 hover:bg-green-700 text-white px-8 py-4 rounded-full text-base font-bold transition-all duration-300 hover:scale-105 hover:shadow-lg whitespace-nowrap cursor-pointer"
          >
            <i className="ri-whatsapp-line text-xl"></i>
            Tirar Dúvidas no WhatsApp
          </a>
        </div>
      </div>
    </section>
  );
}
